import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonComponent, IconComponent } from 'src/app/ui-kit';
import { NgClass } from '@angular/common';
import { Store } from '@ngxs/store';
import { NavigationBarsState } from 'src/app/rxjs-store/navigation-bars';
import { Color, MenuButtonConfig } from 'src/app/models/ui';
import { debounceTime, Subscription } from 'rxjs';
import { UIService } from 'src/app/rxjs-store/ui';

@Component({
  selector: 'app-global-nav-bar',
  templateUrl: './global-nav-bar.component.html',
  styleUrls: ['./global-nav-bar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    IconComponent,
    RouterLink,
    RouterLinkActive,
    NgClass,
  ],
  host: {
    class: 'display: contents',
  },
})
export class GlobalNavBarComponent implements OnInit, OnDestroy {
  @Output() menuButtonClicked = new EventEmitter<void>();
  private stateSubscription?: Subscription;
  private windowWidthSubscription?: Subscription;
  visible: boolean | null = null;
  menuButton: MenuButtonConfig = { visible: false, icon: 'menu' };
  color!: Color;
  transparent: boolean = false;
  content: any[] = [];
  minWidth: string = '0rem';
  constructor(
    private store: Store,
    private cdr: ChangeDetectorRef,
    private uiService: UIService
  ) {}

  ngOnInit() {
    this.stateSubscription = this.store
      .select(NavigationBarsState.bottomNavBar)
      .subscribe((bottomNavBar) => {
        this.menuButton = bottomNavBar.menuButton ?? {
          visible: true,
          icon: 'menu',
        };
        this.content = bottomNavBar.content;
        this.visible = bottomNavBar.visible;
        this.color = bottomNavBar.color ?? 'surface';
        this.transparent = bottomNavBar.transparent ?? false;
        this.calculateMinWidth();
        this.cdr.markForCheck();
      });
    this.windowWidthSubscription = this.uiService.windowWidth$
      .pipe(debounceTime(0))
      .subscribe((width) => {
        this.calculateMinWidth();
        this.cdr.markForCheck();
      });
  }

  calculateMinWidth() {
    const isSmallerThanMediumScreen =
      this.uiService.getIsSmallerThanMediumScreen();
    if (isSmallerThanMediumScreen) {
      // this.minWidth = '100%';
      // return;
    }
    let minWidth = 0;
    if (this.menuButton.visible) {
      minWidth += 5;
    }
    minWidth += (this.content?.length ?? 0) * 5;

    // Add 1rem for each side of the padding
    minWidth += 2;
    this.minWidth = minWidth + 'rem';
  }

  ngOnDestroy() {
    this.stateSubscription?.unsubscribe();
    this.windowWidthSubscription?.unsubscribe();
  }
}
